export interface ISubscription {
  id: string,
  name: string;
  status: string;
  cancelAtPeriodEnd: boolean;
  quantity: number;
  currency: string;
  interval: SubscriptionPeriod;
  trialEnd: string;
  periodEnd: string;
  periodEnded: boolean;
  priceId: string;
  productId: string;
  customerId: string;
  couponId: string | null;
}

export interface SubcsriptionSliceInitialState {
  subscriptionInfo: ISubscription | null;
  isLoading: boolean;
}

export interface IAddUpdateSubscriptionData {
  subscriptionId: string;
  priceId: string;
  quantity: number;
  couponId: string | null;
}

export type SubscriptionPeriod = "month" | "year"

export enum SubscriptionStatus {
  Active = "active",
  Canceled = "canceled",
  Incomplete = "incomplete",
  IncompleteExpired = "incomplete_expired",
  PastDue = "past_due",
  Trialing = "trialing",
  Unpaid = "unpaid"
}
